import {AdapterProps, FieldAdapter} from '../field-factory';
import {
  SegmentedControl as MantineSegmentedControl,
  SegmentedControlItem,
  SegmentedControlProps,
} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';
import {AnyObject} from '../../types';
import {getEnumSegmentedOptions} from '../../api/utils';

export type $SegmentedControlAdapterProps = AdapterProps<
  Omit<SegmentedControlProps, 'data'>
> & {
  enum?: AnyObject;
  data?: string[] | SegmentedControlItem[];
};

export const $SegmentedControlAdapter: FC<
  FieldAdapter<$SegmentedControlAdapterProps>
> = ({
  inputProps: {data = [], enum: enumObject, disabled, onChange, ...inputProps},
  control,
}) => {
  const {readOnly} = useContext(ReadOnlyContext);
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
  } = control;

  const _onChange: SegmentedControlProps['onChange'] = (value) => {
    fieldOnChange(value);
    onChange?.(value);
  };

  const _data = enumObject ? getEnumSegmentedOptions(enumObject) : data;

  return (
    <MantineSegmentedControl
      data={_data}
      disabled={disabled || readOnly}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};